export const FEATURED_POSTS_COLLECTION_SLUG = 'featured-posts'
export const GEAR_SLUG = 'gear'
export const PREGNANCY_SLUG = 'pregnancy'
export const PREGNANCY_WEEK_BY_WEEK_SLUG = 'pregnancy-week-by-week'
export const PARENTING_SLUG = 'parenting'
export const SAMPLE_REGISTRIES_SLUG = 'sample-registries'
export const FRIENDS_AND_FAMILY_SLUG = 'friends-and-family'
